"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Tray component.
 *
 * This is the actual tray that the dropdown menu opens up. It is where the
 * content of the dropdown is rendered.
 *
 * @class Tray
 * @public
 */
const Tray = /*#__PURE__*/(0, _react.forwardRef)(function Tray({
  className,
  children,
  open,
  renderClosed
}, ref) {
  const renderChildren = open || renderClosed;
  const [isBrowser, setIsBrowser] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setIsBrowser(true);
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    className: (0, _classnames.default)(className, 'tray-dropdown', isBrowser && 'loaded')
  }, renderChildren && /*#__PURE__*/_react.default.createElement("div", {
    className: "tray-content"
  }, children));
});
var _default = exports.default = Tray;
/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */
Tray.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  open: _propTypes.default.bool,
  renderClosed: _propTypes.default.bool
};